<template>
  <div class="modals" :class="{ active: isHandledOpenModalProofCancleProject }">
    <!-- Close Icon -->
    <div
      @click="closeModalProofCancelProject"
      class="is-flex is-absolute"
      style="top: 2rem; right: 2rem"
    >
      <XMarkIcon color="#ffffff" size="15px" class="is-clickable" />
    </div>

    <!-- Modal Content -->
    <div class="content-modal-proof-cancel" :class="{ active: showModalProofCancelProject }">
      <div
        class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center gap-8 c-w-100 c-h-100"
      >
        <!-- Main Thumbnail Photo -->
        <div class="main-thumbnail-photo">
          <img
            v-if="dataThumbnail && dataThumbnail[selectedThumbnailIndex]"
            :src="dataThumbnail[selectedThumbnailIndex]"
            alt="thumbnail"
          />
        </div>

        <!-- Sub Menu Thumbnail Photo -->
        <div
          class="is-flex is-flex-direction-row is-justify-content-space-evenly is-align-items-center gap-4 c-w-100"
          style="overflow-x: auto; min-height: 100px"
        >
          <div
            v-for="(item, index) in dataThumbnail"
            :key="index"
            class="sub-menu-thumbnail-photo"
            :class="{ selected: index === selectedThumbnailIndex }"
            @click="handleSelectThumbnail(index)"
          >
            <img v-if="item" :src="item" alt="thumbnail" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XMarkIcon } from '@/components/icons'

export default {
  name: 'ModalProofCancelProject',
  props: {
    isHandledOpenModalProofCancleProject: {
      type: Boolean,
      default: false
    },
    dataThumbnail: {
      type: Array,
      default: () => []
    }
  },
  components: {
    XMarkIcon
  },
  data () {
    return {
      showModalProofCancelProject: false,
      selectedThumbnailIndex: 0
    }
  },
  methods: {
    closeModalProofCancelProject () {
      this.showModalProofCancelProject = false
      this.$emit('closeModalProofCancelProject')
    },
    handleSelectThumbnail (index) {
      this.selectedThumbnailIndex = index
    }
  },
  watch: {
    isHandledOpenModalProofCancleProject (val) {
      this.showModalProofCancelProject = val
    }
  }
}
</script>

<style scoped>
.modals {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(0);
  z-index: -1;
  opacity: 0;
  transition: backdrop-filter 0.5s ease-in-out, z-index 0.5s ease-in-out,
    background 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.modals.active {
  z-index: 9999;
  backdrop-filter: blur(5px);
  opacity: 1;
  background: rgba(0, 0, 0, 0.5);
}

.content-modal-proof-cancel {
  position: absolute;
  top: -35%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 30%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  border-radius: 20px;
  background: transparent;
  transition: top 0.35s ease-in-out, opacity 0.25s ease-in-out, width 0.25s ease-in-out,
    min-width 0.25s ease-in-out, max-width 0.25s ease-in-out, height 0.25s ease-in-out;
  opacity: 0;
}

.content-modal-proof-cancel.active {
  top: 50%;
  opacity: 1;
  width: 350px;
  min-width: 350px;
  max-width: 350px;
  height: 75%;
}

.main-thumbnail-photo {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 350px;
  max-width: 350px;
  height: 100%;
  min-height: 350px;
  max-height: 350px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  border-radius: 20px;
  background: #ffffff;
}

.main-thumbnail-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sub-menu-thumbnail-photo {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 70px;
  max-width: 70px;
  height: 100%;
  min-height: 70px;
  max-height: 70px;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  background: #ffffff;
  cursor: pointer;
}

.sub-menu-thumbnail-photo.selected {
  border: 4px solid #d5262e;
}

.sub-menu-thumbnail-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

*::-webkit-scrollbar-track {
  position: absolute !important;
  background: transparent !important;
  top: 50px !important;
}
</style>
